import { render, staticRenderFns } from "./contacts-add.vue?vue&type=template&id=6f609faa&scoped=true&"
import script from "./contacts-add.vue?vue&type=script&lang=js&"
export * from "./contacts-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f609faa",
  null
  
)

export default component.exports